import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css } from 'lit'

const CSCComposableWeightCalculator = {
  mainGap: css`var(--csc-composable-weight-calculator-main-gap, ${csSpacing.spacing08})`,
  contentGap: css`var(--csc-composable-weight-calculator-content-gap, ${csSpacing.spacing08})`,
  pricesGap: css`var(--csc-composable-weight-calculator-content-gap, ${csSpacing.spacing05})`,
  orderFormGap: css`var(--csc-composable-weight-calculator-order-form-gap, ${csSpacing.spacing05})`
}

export const style = css`
  .composable-weight-calculator {
    display: flex;
    flex-direction: column;
    gap: ${CSCComposableWeightCalculator.mainGap}
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: ${CSCComposableWeightCalculator.contentGap};
  }

  .prices {
    display: flex;
    flex-direction: column;
    gap: ${CSCComposableWeightCalculator.pricesGap};
  }

  .order-form {
    display: flex;
    align-items: center;
    gap: ${CSCComposableWeightCalculator.orderFormGap};
  }

  .hidden {
    display: none;
  }
`
